<template>
  <Dialog v-model:open="open">
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Shortcuts / Help</DialogTitle>
      </DialogHeader>
      <div class="px-7 pb-6 pt-5">
        <Table>
          <TableBody>
            <TableRow
              v-for="(row, index) in tableData"
              :key="index"
              class="border-neutral-700"
            >
              <TableCell class="text-neutral-200 py-3">
                <strong class="font-semibold">{{ row.trigger }}</strong>
                <span v-if="row.extra" class="text-neutral-600 ml-1">
                  {{ row.extra }}
                </span>
              </TableCell>
              <TableCell class="py-3">
                {{ row.help }}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </DialogContent>
  </Dialog>
</template>

<script setup>
import { ref } from 'vue';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  DialogHeader,
} from '@ui/components/dialog';
import { Table, TableBody, TableCell, TableRow } from '@ui/components/table';

const tableData = ref([
  {
    trigger: 'Double click',
    extra: 'in empty workspace',
    help: 'create element',
  },
  {
    trigger: '@',
    extra: 'while typing',
    help: 'mention component/board',
  },
  {
    trigger: 'Tab',
    extra: 'while typing',
    help: 'switch between element title/content',
  },
  {
    trigger: 'Ctrl/Cmd + C/X',
    help: 'copy / cut',
  },
  {
    trigger: 'Ctrl/Cmd + V',
    help: 'paste',
  },
  {
    trigger: 'Ctrl/Cmd + Shift + V',
    help: 'paste single copied element as jumper',
  },
  {
    trigger: 'Ctrl/Shift/Cmd + drag',
    help: 'rectangle-selection',
  },
  {
    trigger: 'Ctrl/Shift/Cmd + click',
    help: 'select multiple',
  },
  {
    trigger: 'Ctrl/Cmd + A',
    help: 'select all board items',
  },
  {
    trigger: 'Ctrl/Cmd + F',
    help: 'search',
  },
  {
    trigger: '+',
    help: 'zoom in',
  },
  {
    trigger: '-',
    help: 'zoom out',
  },
  {
    trigger: '0',
    help: 'zoom to 100%',
  },
  {
    trigger: 'f',
    help: 'focus to board contents/selection',
  },
  {
    trigger: 'Delete, Backspace',
    help: 'delete selected board items',
  },
  {
    trigger: 'Ctrl/Cmd + Z',
    help: 'undo last action',
  },
  {
    trigger: 'Ctrl/Cmd + Shift + Z',
    help: 'redo last action',
  },
  {
    trigger: 'Right click',
    extra: 'any item',
    help: 'open item menu',
  },
  {
    trigger: 'Ctrl/Cmd + Shift + \\',
    extra: '\nin element',
    help: 'toggle actionscript block',
  },
  {
    trigger: 'Arrow keys',
    extra: 'without selection',
    help: 'pan board',
  },
  {
    trigger: 'Arrow keys',
    extra: 'with selection',
    help: 'nudge selection',
  },
]);
</script>
